import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'cc-integration-error',
  templateUrl: './integration-error.component.html',
  styleUrls: ['./integration-error.component.scss']
})
export class IntegrationErrorComponent implements OnInit {
  public errorKey: string;
  public type: string | undefined;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    const integrationType = this.route.snapshot.paramMap.get('integratedPlatformType');
    const errorKey = this.route.snapshot.paramMap.get('error');

    this.errorKey = `INTEGRATIONS.${integrationType.toUpperCase()}.ERRORS.${errorKey.toUpperCase()}`;
    this.type = this.capitalize(this.route.snapshot.queryParamMap.get('type'));
  }

  private capitalize(string: string): string {
    return string && string.charAt(0).toUpperCase() + string.slice(1).toLocaleLowerCase();
  }
}
